var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8489 14.3572C13.9856 14.3572 15.0757 13.9057 15.8794 13.1019C16.6831 12.2982 17.1347 11.2081 17.1347 10.0715C17.1347 8.93484 16.6831 7.84475 15.8794 7.04102C15.0757 6.2373 13.9856 5.78577 12.8489 5.78577C11.7123 5.78577 10.6222 6.2373 9.81849 7.04102C9.01476 7.84475 8.56323 8.93484 8.56323 10.0715C8.56323 11.2081 9.01476 12.2982 9.81849 13.1019C10.6222 13.9057 11.7123 14.3572 12.8489 14.3572Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52881 21.0429C6.29379 19.7872 7.36894 18.7494 8.65088 18.0293C9.93282 17.3091 11.3785 16.9309 12.8488 16.9309C14.3192 16.9309 15.7648 17.3091 17.0467 18.0293C18.3287 18.7494 19.4038 19.7872 20.1688 21.0429",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8489 23.7857C15.8042 23.7857 18.6384 22.6117 20.7281 20.522C22.8178 18.4324 23.9918 15.5981 23.9918 12.6429C23.9918 9.68759 22.8178 6.85336 20.7281 4.76367C18.6384 2.67398 15.8042 1.5 12.8489 1.5C9.89364 1.5 7.05941 2.67398 4.96972 4.76367C2.88003 6.85336 1.70605 9.68759 1.70605 12.6429C1.70605 15.5981 2.88003 18.4324 4.96972 20.522C7.05941 22.6117 9.89364 23.7857 12.8489 23.7857Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.6714af51c1ffce4b54456af6fb78db32.svg";
export { ForwardRef as ReactComponent };